/* eslint-disable @typescript-eslint/naming-convention */

export const SET_VISION_ORG = 'SET_VISION_ORG';